/*
 * Purpose : Component to Add or Edit Locations
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React,{useState} from "react";
import {  Col,  Row,  Button,  Form,  FormGroup,  Label,  Input,  CustomInput,  Alert} from "reactstrap";

import "./AddEditLocations.css";
import Aux from "../../hoc/Auxilliary/Auxilliary";

const AddEditLocations = (props) => {
    const [location, setLocation] = useState(props.stateVals.location);
    const [enableFlag, setEnableFlag] = useState(props.stateVals.enable==="Yes"?true:false)
    const [errors, setErrors] = useState({location:"",validLocation:true})
    const [processing, setProcessing] = useState(false)
   
    const locationChangeHandler= (value) => {
        setLocation(value)        
        if(!value){
          setErrors({...errors, location:'Location is not valid!'})
        }
    }

    const submithandler =() => {
        if(!location){
            setErrors({...errors, validLocation:false})
        }else{
            setErrors({...errors, validLocation:true})
            setProcessing(true)
            props.submithandler(props.stateVals.id,location,enableFlag,props.stateVals.action)
        }
    }

    return (
    <Aux>
      <Form>
        <Alert color="danger" isOpen={!errors.validLocation}>Valid Location is required.</Alert>
        <Row form>
          <Col md={12}>
            <FormGroup>
              <Label for="location">Location</Label>
              <Input
                type="text"
                name="location"
                id="location"
                placeholder=""
                value={location}
                onChange={(e) => locationChangeHandler(`${e.target.value}`)}
              />
            </FormGroup>
          </Col>
        </Row>
        {errors.location.length > 0 && <span style={{ color:"#db2269", fontSize: "1em",  display: "relative" }} >{errors.location}</span>}
        <Row>
          <FormGroup check>
            <div>
              <CustomInput
                type="checkbox"
                id="enableFlag"
                checked={enableFlag}
                onChange={(e) => setEnableFlag(!enableFlag)}
                label="Enable"
              />
            </div>
          </FormGroup>
        </Row>        
        <FormGroup style={{textAlign: "center", marginTop:"1rem"}}>
            <Row>
              <Col>
                <Button color="primary" className={"locationFormBtn"} style={{backgroundColor:"#fb8734"}}
                        value="" 
                        onClick={()=>submithandler()}
                        disabled={processing}>
                        { processing && <span><i className="fa fa-spinner fa-spin"></i>  Processing... </span> }
                        { !processing && <span>Submit</span> }                                
                </Button>
              </Col>
              <Col>
                <Button color="secondary" className={"locationFormBtn"} value="" onClick={props.closeHandler}>Close</Button>
              </Col>
            </Row>
        </FormGroup>
      </Form>
    </Aux>
  );
};
export default AddEditLocations;